import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'src/environments/environment.dev';

@Pipe({
    name: 'assetUrl',
    standalone: true
})
export class AssetUrlPipe implements PipeTransform {
    transform(path: string): string {
        return `${environment.s3Url}/inndoc-ai/assets/${path}`;
    }
}
